import React from "react";
import PropTypes from "prop-types";
import { Button, Typography } from "@mui/material";
import EnhancedCard from "common/components/EnhancedCard";
import NotificationList from "core/Notifications/List";
import Resource from "common/components/Resource";
import { connect } from "react-redux";
import { urlResource } from "common/utils";
import { useTranslation } from "react-i18next";

const NotificationsListing = ({ resource, history }) => {
  const { t } = useTranslation();
  return (
    <EnhancedCard
      title={t("updates_list.title")}
      cardContentRoot={{ padding: 0 }}
      cardHeaderStyle={{ fontSize: "1.25rem" }}
      action={
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            history.push(
              `/${resource.singular}/${resource.id}/notifications/new`,
            );
          }}
        >
          {t("updates_list.create_btn")}
        </Button>
      }
    >
      <Resource
        name={`${resource.plural}/${resource.id}/notifications`}
        queryParams={{}}
        error={() => <Typography>Could not load notifications</Typography>}
        render={(data, { removeOne }) => (
          <NotificationList notifications={data} removeOne={removeOne} />
        )}
      />
    </EnhancedCard>
  );
};

NotificationsListing.propTypes = {
  resource: PropTypes.shape({
    id: PropTypes.number.isRequired,
    singular: PropTypes.string.isRequired,
    plural: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const mapStateToProps = (state, { match }) => ({
  resource: urlResource(match.path),
});

export default connect(mapStateToProps)(NotificationsListing);
